import { Card } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Customized,
} from "recharts";
import { formatMinutes, Resolution } from "../utils";
import { BarDataItem } from "../types";
import HolidayOverlay from "./HolidayOverlay";
import BarTooltip from "./BarTooltip";
import HolidayLegend from "./HolidayLegend";

interface BarEntry {
  key: string;
  color: string;
}

interface ActivityChartProps {
  barData: BarDataItem[];
  breakdownKeys: BarEntry[];
  resolution: Resolution;
}

const ActivityChart = ({
  barData,
  breakdownKeys,
  resolution,
}: ActivityChartProps) => (
  <Card bodyStyle={{ padding: "16px 8px" }} style={{ marginBottom: 16 }}>
    {resolution === "day" && <HolidayLegend />}
    <ResponsiveContainer width="100%" height={280}>
      <BarChart
        data={barData}
        margin={{ top: 16, right: 16, left: 0, bottom: 0 }}
      >
        <XAxis dataKey="date" tick={{ fontSize: 11 }} />
        <YAxis
          tickFormatter={(v) => formatMinutes(v)}
          tick={{ fontSize: 11 }}
          width={55}
        />
        <Tooltip content={<BarTooltip />} />
        {breakdownKeys.map((item) => (
          <Bar
            key={item.key}
            dataKey={item.key}
            stackId="a"
            fill={item.color}
          />
        ))}
        {resolution === "day" && <Customized component={HolidayOverlay} />}
      </BarChart>
    </ResponsiveContainer>
  </Card>
);

export default ActivityChart;
